<template>
  <div
    class="spinnerholder"
    v-if="isUpdatingHorario" >
    <SpinText
      :text="$t('apesquisarhorario')"
      class="spinner"/>
  </div>
  <calendario 
    class="calendario"
    v-if="showcalendar"
    :lang="$i18n.locale"
    :cellheigth="35"
    :smallCellMultiplier="1"
    :shortcalendar="true"
    :weekstart="selectedWeek.start"
    :aulas="aulas"/>
  <EventList
    v-show="showlist"
    ref="eventList2"
    :lang="$i18n.locale"
    :weekstart="selectedWeek.start" 
    :aulas="aulas">
    <template #event="{ sortedCalendario, key, lang, eventColors }">
      <EventItem 
        :key="event.id" 
        v-for="event in sortedCalendario[key]"
        :lang="lang" 
        class="eventItem"
        :colorbackground="eventColors[event.cadeira].body" 
        :colorseparador="eventColors[event.cadeira].header"
        :horaInicio="event.horaInicio" 
        :horaFim="event.horaFim" 
        :disciplina="event.cadeira" 
        :tipo="event.tipo"
        :sala="event.sala_desc" 
        :ano="event.ano" 
        :turma="event.turma" 
        :curso="event?.cursos"
        :professor="event.docente">
        <template #subtitulolivre>
          {{$t('avaliacao')}} - {{ event.tipo }} - {{ event.cadeira }}
        </template>
      </EventItem>
    </template>
  </EventList>
</template>

<script>
import { computed, watch, onMounted } from "vue";
import SpinText from '@/components/spinLoaderText.vue';
import EventosDisplayer from '@/containers/desktop/eventosdisplayer.vue';
import { useHorarios } from "@/stores/horarios.ts";
import { calendario, EventList, EventItem } from "umaui";

export default {
  name: "ResultsDisplayer",
  props:["searchedFilter","selectedWeek"],
  components:{
    SpinText,
    EventosDisplayer,
    calendario,
    EventList,
    EventItem
  },
  setup(props){
    const horariosStore = useHorarios();
    const isUpdatingHorario = computed(()=>horariosStore.isUpdatingHorario);
    let aulas = computed(()=>horariosStore.aulas);
    return {
      isUpdatingHorario,
      aulas,
      calendario
    }
  },
  computed:{
    showcalendar(){
      return this.searchedFilter && !this.isUpdatingHorario && this.searchedFilter.id !== 3;
    },
    showlist(){
      return (
        this.searchedFilter && !this.isUpdatingHorario && this.searchedFilter.id == 3
      )
    },
  },
  methods: {},
};
</script>

<style scoped>
.calendario{
  /*fixes problem with safari and z-index*/
  -webkit-transform: translate3d(0,0,0);
  margin-top: 10px;
}

.spinnerholder{
  position: relative;
  margin-top: 100px;
}
</style>
